import { useMemo } from 'react';
import { useOpts } from '../../context';
import useRoutingNumberField from './useRoutingNumberField';
import { WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING } from '../../consts/routing-number-mappings';
function useBankInfoInputFields() {
    var workspaceName = useOpts().linkTokenPayload.workspaceName;
    var routingNumberField = useRoutingNumberField();
    var fieldConfigs = useMemo(function () {
        var baseFieldConfigs = [
            {
                fieldType: 'text',
                fieldSubtype: 'plaintext',
                key: 'accountNumber',
                label: 'Account number',
                minLength: 5,
                maxLength: 17,
                pattern: '[0-9]+',
                required: true,
            },
            {
                fieldType: 'toggleButtonGroup',
                key: 'accountType',
                label: '',
                options: [
                    { value: 'checking', label: 'Checking' },
                    { value: 'savings', label: 'Savings' },
                ],
                required: true,
            },
        ];
        if (workspaceName in WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING) {
            return baseFieldConfigs;
        }
        baseFieldConfigs.unshift(routingNumberField);
        return baseFieldConfigs;
    }, [routingNumberField, workspaceName]);
    return fieldConfigs;
}
export default useBankInfoInputFields;
